import getScenarioStore from '../selectors/getScenarioStore';
import { addSuggestionPillInternal } from '../actions/internalActions';
import { mutator } from 'satcheljs';
import { PillSuggestion } from 'owa-search-service';

export default mutator(addSuggestionPillInternal, actionMessage => {
    const searchStore = getScenarioStore(actionMessage.scenarioId);

    const suggestionPill: PillSuggestion = actionMessage.suggestionPill;
    const pillId = suggestionPill.ReferenceId;

    /**
     * Add the suggestion pill to the collection, as well as adding its ID to
     * the array of IDs to maintain order.
     */
    searchStore.suggestionPills.set(pillId, suggestionPill);
    searchStore.suggestionPillIds.push(pillId);
});
